module.exports = __webpack_public_path__ + "img/mirror07.108ee6db.jpg";